<template>
	<!-- <header>
    <a href="https://www.yuanquanyun.com.cn/">
      <svg-icon class="logo" iconClass="logo"/>
    </a>
    <span class="logo-s-title">{{stitle}}</span>
    <a href="javascript:;" @click="returnIndex" v-show="stitle" class="return-index"> <返回首页 </a>
    
  </header> -->

	<el-header class="head" height="71">
		<span class="logo">
			<img :src="logoSrc" alt="">
		</span>
		<span>
			电子合同服务平台
		</span>
	</el-header>
</template>
<script>
	export default {
		props: ["stitle"],
		data() {
			return {
				logoSrc: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL) ? GLOBAL_CONFIG.APP_STATIC_RESOURCE_URL : process.env.VUE_APP_STATIC_RESOURCE_URL) + "pc/logo.png"
			}
		},
		methods: {
			returnIndex() {
				this.$router.push("/");
			}
		}
	};
</script>
<style lang="scss" scoped>
	.head {
		height: 71px;
		line-height: 71px;
		color: #ffffff;
		.logo {
			text-align: center;
			margin-left: 10px;
			img {
				width: 100px;
				height: auto;
				vertical-align: middle;
			}
		}
		span {
			font-size: 18px;
			font-weight: 400;
			margin-left: 24px;
		}
	}

	header {
		width: 100%;
		height: 71px;
		background: rgba(35, 43, 58, 1);
		box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
		line-height: 71px;
		overflow: hidden;
	}

	.header-center {
		width: 1200px;
		margin: 0 auto 0;
	}

	// .logo {
	// 	margin-top: 16px;
	// 	margin-left: 37px;
	// 	width: 126px;
	// 	float: left;
	// }

	// .logo-text {
	// 	margin-left: 31px;
	// 	font-size: 24px;
	// 	color: #ffffff;
	// }

	.logo-s-title {
		font-size: 24px;
		color: #ffffff;
		margin-left: 24px;
	}

	.return-index {
		height: 71px;
		display: block;
		position: absolute;
		right: 56px;
		top: 0;
		font-size: 24px;
		color: #ffffff;
		line-height: 71px;
	}
</style>